export default {
  es: {
    label: {
      lang: 'Idiomas',
      tableNumber: 'Número de Mesa',
      search: 'Buscar',
      autoSelect: 'Selección automática',
      add: 'Añadir',
      total: 'Total',
      note: 'Nota',
      confirmOrder: 'Confirmar el pedido',
      confirmToPay: 'Confirmación del pago',
      phone: 'Teléfono',
      address: 'Dirección',
      needPayBill: 'Facturación',
      waiter: 'Camarero',
      member: 'Miembros',
      memberTip: 'Número de membresía/teléfono',
      type: 'Tipo',
      receipt: 'Boleta',
      invoice: 'Factura',
      idNumber: 'DNI',
      taxNumber: 'RUC',
      check: 'Verificación',
      personalName: 'Apellido y Nombre',
      companyName: 'Nombre de la empresa',
      companyAddress: 'Dirección de la empresa',
      payMethod: 'Método de pago',
      starPayDiscount: 'StarPay Descuento',
      discountCode: 'Número de descuento',
      cash: 'Efectivo',
      transfer: 'Transferencias',
      payCode: 'Número de transaccion',
      confirm: 'Confirmación',
      cancel: 'Cancelación',
      all: 'Todo',
      reset: 'Restablecer',
      takeOutInfo: 'Delivery',
      unpayed: 'Impagos',
      custom: 'Personalizado',
      customer: 'Cliente',
      discount: 'Descuento',
      password: 'Contraseña',
      login: 'Acceso',
    },
    message: {
      needMoreInfo: 'Por favor, complete la información',
      confirmDelete: 'Confirmar la eliminación?',
      deleted: 'Eliminado',
      promopt: 'Consejos',
      addFood: 'Por favor, agregue el producto',
      error: 'Error',
      productionOrder: 'Orden de producción',
      order: 'Pedidos',
      payment: 'Pago',
      noRecord: 'No hay registros relevantes',
      discountError: 'Error de descuento',
      loginFirst: 'Por favor, inicie sesión primero.',
      membershipLapsed: 'Membresía caducada',
      notEnoughMemberBalance: 'Saldo de las cuentas de los miembros',
    },
  },
  zh: {
    label: {
      lang: '语言',
      tableNumber: '桌号',
      search: '搜索',
      autoSelect: '自动添加',
      add: '添加',
      total: '合计',
      note: '备注',
      confirmOrder: '确认下单',
      confirmToPay: '确认付款',
      phone: '电话',
      address: '地址',
      needPayBill: '开票',
      waiter: '服务员',
      member: '会员',
      memberTip: '编号/手机号',
      type: '类型',
      receipt: '收据',
      invoice: '发票',
      idNumber: '身份证号',
      taxNumber: '公司税号',
      check: '校验',
      personalName: '个人姓名',
      companyName: '公司名称',
      companyAddress: '公司地址',
      payMethod: '付款方式',
      starPayDiscount: 'StarPay优惠',
      discountCode: '优惠编号',
      cash: '现金',
      transfer: '转账',
      payCode: '付款编号',
      confirm: '确认',
      cancel: '取消',
      all: '全部',
      reset: '重置',
      takeOutInfo: '外卖信息',
      unpayed: '未付款',
      custom: '自定义',
      customer: '客户',
      discount: '折扣',
      password: '密码',
      login: '登陆',
    },
    message: {
      needMoreInfo: '请将信息填写完整',
      confirmDelete: '确认删除？',
      deleted: '已删除',
      promopt: '提示',
      addFood: '请添加商品',
      error: '错误',
      productionOrder: '生产单',
      order: '订单',
      payment: '支付',
      noRecord: '没有相关记录',
      discountError: '折扣错误',
      loginFirst: '请先登陆',
      membershipLapsed: '会员已失效',
      notEnoughMemberBalance: '会员余额不足',
    },
  },
}



// WEBPACK FOOTER //
// ./src/locale/message.js